import { stickyNavOnScroll } from '../utils/stickyNavOnScroll';
import { enableScrollLock, disableScrollLock } from '../utils/scrollLock';
import { currentBreakpoint } from '../utils/windowResize';

export let nav;
export let navWidth;

let firstNavItem = -1;
let navItemsWithChildren = -1;

export function toggleMenuOpen() {
    if (nav.classList.contains('nav--open')) {
        disableScrollLock();
        nav.classList.remove('nav--opened')
        nav.classList.remove('nav--open');

        const activeItem = Array.prototype.slice.call(navItemsWithChildren).filter(x => x.classList.contains('js-active'));

        if (firstNavItem != undefined && currentBreakpoint != 'xxs' && currentBreakpoint != 'xs') {
            if (firstNavItem != activeItem) {
                firstNavItem.classList.add('js-active');
            }
        } else if (currentBreakpoint == 'xxs' || currentBreakpoint == 'xs') {
            if (activeItem.length == 1) {
                activeItem[0].classList.remove('js-active');
            }

            firstNavItem.classList.remove('js-active');
            nav.classList.add('js-none-selected');
        }

        if (window.pageYOffset > 50) {
            setTimeout(() => nav.classList.add('going-up'), 40);
        }
    } else {
        enableScrollLock();
        nav.classList.add('nav--open');
    }
}

export function setupNav(selector = '.nav', sticky = true) {
    nav = document.body.querySelector(selector);

    if (nav) {
        navWidth = nav.offsetWidth;
        const navBtn = nav.querySelector('.nav__btn');
        const navItems = nav.querySelectorAll('.nav__item');
        navItemsWithChildren = Array.prototype.slice.call(navItems).filter(x => x.hasAttribute('data-has-children'));
        firstNavItem = nav.querySelector('.nav__menu > .icon-nav-active + .nav__item');
        const lastNavItem = nav.querySelector('.nav__menu > .nav__item:last-child');
        const firstSubItem = nav.querySelector('.nav__menu .nav__sub li:first-child');
        const navSearch = nav.querySelector('.nav__item--search');
        const navActiveIcon = nav.querySelector('.icon-nav-active');
        const mobileBack = nav.querySelector('.nav__mobile-back');
        const navBottomBar = nav.querySelector('.nav__bottom-bar');

        function toggleSubMenuActive(e) {
            const item = e.target.closest('li');
            const activeItem = Array.prototype.slice.call(navItemsWithChildren).filter(x => x.classList.contains('js-active'));

            if (activeItem.length == 1) {
                if (item != activeItem[0]) {
                    activeItem[0].classList.remove('js-active');
                    updateItem(item);
                }
            } else {
                updateItem(item);
            }

            function updateItem(item) {
                item.classList.add('js-active');

                let diff = item.getBoundingClientRect().top.toFixed(0) - firstNavItem.getBoundingClientRect().top;
                diff = diff < 0 ? diff * -1 : diff;

                if ((currentBreakpoint != 'xxs' && currentBreakpoint != 'xs')) {
                    navActiveIcon.style.transform = `translate3d(0,${diff}px,0)`;
                }

                if (currentBreakpoint == 'xxs' || currentBreakpoint == 'xs') {
                    nav.classList.remove('js-none-selected');
                }

                const itemUl = item.querySelector('ul');

                if (itemUl != undefined && (currentBreakpoint == 'xxs' || currentBreakpoint == 'xs')) {
                    itemUl.style.height = `${itemUl.scrollHeight}px`;
                }
            }
        }

        navBtn.addEventListener('click', toggleMenuOpen);

        if (sticky) {
            stickyNavOnScroll(nav, 'nav--sticky', 30, 'going-up');
        }

        for (let a = 0, l = navItemsWithChildren.length; a < l; a++) {
            navItemsWithChildren[a].addEventListener('click',toggleSubMenuActive);
        }

        if (lastNavItem != undefined) {
            lastNavItem.addEventListener('transitionend', function () {
                if (nav.classList.contains('nav--open')) {
                    nav.classList.add('nav--opened')
                }
            });
        }

        if ((currentBreakpoint != 'xxs' && currentBreakpoint != 'xs' && currentBreakpoint != 'sm' && currentBreakpoint != 'md') && (navSearch != undefined && firstSubItem != undefined)) {
            let diff = navSearch.getBoundingClientRect().left.toFixed(0) - firstSubItem.getBoundingClientRect().left.toFixed(0);
            diff = diff < 0 ? diff * -1 : diff;

            navSearch.style.marginLeft = `${diff}px`;
        }

        if (navBottomBar != undefined) {
            if (navSearch != undefined) {
                const navSearchInput = navSearch.querySelector('input');

                if (navSearchInput != undefined) {
                    function toggleSearch() {
                        if (currentBreakpoint == 'xxs' || currentBreakpoint == 'xs') {
                            if (navSearchInput == document.activeElement) {
                                navBottomBar.classList.add('js-search');
                            } else {
                                navBottomBar.classList.remove('js-search');
                            }
                        }
                    }

                    navSearchInput.addEventListener('focus', toggleSearch);
                    navSearchInput.addEventListener('blur', toggleSearch);
                }
            }
        }

        if (firstNavItem != undefined && currentBreakpoint != 'xxs' && currentBreakpoint != 'xs') {
            firstNavItem.classList.add('js-active');
        } else {
            nav.classList.add('js-none-selected');
        }

        if (currentBreakpoint == 'xxs' || currentBreakpoint == 'xs') {
            for (let a = 0, l = navItems.length; a < l; a++) {
                const h = navItems[a].offsetHeight;
                navItems[a].style.height = `${h}px`;
            }
        }

        if (mobileBack != undefined) {
            mobileBack.addEventListener('click',function() {
                const activeItem = Array.prototype.slice.call(navItemsWithChildren).filter(x => x.classList.contains('js-active'));

                if (activeItem.length == 1) {
                    activeItem[0].classList.remove('js-active');
                    nav.classList.add('js-none-selected');
                }
            });
        }
    }
}
